const __request = require(`./__request/__request_contentType_form`);

// 行程订单申请支付
const recordCount = (data) => {
let pParameter = {
    method: 'post',
    urlSuffix: '/flight/domestic/buyer/manage/itineraryOrder/apply',
    data:data
  }

  return __request(pParameter)
}
export default recordCount
